import { ssrBffGet } from '../bff-api/bff';
import { PageUrl } from '../pages/utils/page-url';

const BFF_RIO_ENDPOINT = '/rio-seo/data';

export type TagAttributes = Record<string, string>;

export type RioData = {
    title: string;
    metaTags: TagAttributes[];
    linkTags: TagAttributes[];
    headContent: string;
    content: string;
};

export async function getRioSeoData(url: string): Promise<RioData> {
    return ssrBffGet<RioData>(BFF_RIO_ENDPOINT, { httpParams: [{ url }] });
}

export const escapeForRegexp = (str: string): string =>
    str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
export const STORES_PAGE_PATTERN = new RegExp(`^${escapeForRegexp(PageUrl.STORES)}(.*)`);
